import { CONFIGS_UNIQUE_ENTRY_ID } from './init';

export const ConfigsList = (_props: unknown) => {
  window.location.href = `#/configs/${CONFIGS_UNIQUE_ENTRY_ID}`;
  return null;
};
